import { render } from "./BusquedaAsignaciones.vue?vue&type=template&id=46ad4624&ts=true"
import script from "./BusquedaAsignaciones.vue?vue&type=script&lang=ts"
export * from "./BusquedaAsignaciones.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner});
